import { schema } from 'normalizr'
const deliveryRestaurant = new schema.Entity('deliveryRestaurants', {})
export default deliveryRestaurant
